import React from "react";
import Tooltip from "./Tooltip";
import {ICON_TYPES} from "./ListItem";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const ListItemCore = props => {
    const {icon, iconType = '', alertText, iconSize = (iconType === ICON_TYPES.REACT_ICON ? [20, 20] : [32, 32]), iconOnly = false, iconBg, disabled = false, meta, tooltip, children} = props;
    const useTag = iconType === ICON_TYPES.INTERNAL_SVG ? '<use xlink:href="#' + icon + '" />' : null;
    const ReactIcon = iconType === ICON_TYPES.REACT_ICON ? props.icon : null;

    return (
        <>
            {icon !== undefined &&
                <Tooltip title={(tooltip ? tooltip : '')} disable={!iconOnly} aria-hidden={!iconOnly} placement="right" enterNextDelay={100} disableInteractive>
                    <span className={'ch-list-item-icon'}>
                        {iconType === ICON_TYPES.INTERNAL_SVG &&
                            <svg className={'ch-icon-sm'} style={{width: iconSize[0], height: iconSize[1], zIndex:1}} dangerouslySetInnerHTML={{__html: useTag}} viewBox='0 0 128 128' aria-hidden={'true'}/>
                        }
                        {iconType === ICON_TYPES.REACT_ICON &&
                            <ReactIcon aria-hidden={'true'} width={iconSize[0]} height={iconSize[1]}/>
                        }
                        {iconBg &&
                            <svg className={'ch-icon-sm-ol'} style={{width: iconSize[0], height: iconSize[1], position:"absolute"}} dangerouslySetInnerHTML={{__html: useTag}} viewBox='0 0 128 128' aria-hidden={'true'}/>
                        }
                    </span>
                </Tooltip>
            }
            {!iconOnly &&
                <span className={'ch-list-item-text'}>
                    {children}
                </span>
            }

            {meta !== undefined &&
                <span className={'ch-list-item-meta'}>{meta}</span>
            }
            {!iconOnly && disabled && alertText !== undefined && alertText !== '' &&
                <Tooltip title={alertText} placement={'right'}>
                    <WarningAmberIcon sx={{color:'var(--warning-colour)'}} />
                </Tooltip>
            }
        </>
    )
}

export default ListItemCore;